/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import ImportantDates from "../../components/ImportantDates/ImportantDates";
import AboutCard from "../../components/AboutCard/AboutCard";
import auditoriumImage from "../../assets/images/auditorium.jpg";
import mapImage from "../../assets/images/map.png";
import Layout from "../../components/Layout/layout";
import ISSMGE from "../../assets/images/ISSMGE.png";
import IGSLogo from "../../assets/images/IGSlogo.jpg";
import IACMAGLogo from "../../assets/images/IACMAG_logo.png";
const Home = () => {
  const pdfUrl = `${process.env.PUBLIC_URL}/Brochure draft 230522024.pdf`;

  const handleOpenPdfInNewTab = () => {
    window.open(pdfUrl, "_blank");
  };

  return (
    <Layout>
      <main>
        <div className="md:px-24 px-8 flex flex-col items-center mb-20"></div>
        <div className="flex md:justify-center  md:mx-0 mx-8">
          <AboutCard />
        </div>
        <div className="justify-center flex mb-4">
          <div className="flex justify-center items-center w-3/4 border-t-2 border-orange-500 bg-white">
            <div className=" p-4 flex flex-col w-full">
              <div
                className="text-orange-500 font-bold text-2xl mb-12"
                style={{ margin: "auto", paddingBottom: "4rem" }}
              >
                Supported By
              </div>
              <div
                className="flex flex-col lg:flex-row gap-4 items-center"
                style={{ margin: "auto" }}
              >
                <img
                  src={ISSMGE}
                  className="h-48"
                  style={{ paddingRight: "2rem" }}
                />
                <img src={IGSLogo} className="h-48" />
                <img src={IACMAGLogo} className="h-24" />
              </div>
            </div>
          </div>
        </div>
        <div>{/* <ImportantDates /> */}</div>
        <div className="flex flex-row justify-center flex-wrap py-20 items-center">
          <button
            className="p-4 border-orange-500 my-2 border-2 h-20 mx-20 w-64 text-orange-500 font-bold bg-white"
            onClick={handleOpenPdfInNewTab}
          >
            Click to Download Brochure
          </button>
          {/* <a href="https://event.iitg.ac.in/8icragee/abstract_template.docx">
            <button className="p-4 border-orange-500 my-2 border-2 h-20 mx-20 w-64 text-orange-500 font-bold bg-white">
              Click to Download Abstract Template
            </button>
          </a> */}
          {/* <a href="https://cmt3.research.microsoft.com/8ICRAGEE2024/Submission/Index">
            <button className="p-4 border-orange-500 my-2 border-2 h-20 mx-20 w-64 text-orange-500 font-bold bg-white">
              Link for Abstract Submission
            </button>
          </a> */}
        </div>
        <div
          class="bg-cover"
          style={{
            backgroundImage: `url(${auditoriumImage})`,
            height: "600px",
          }}
        >
          <div className="flex md:flex-row flex-col justify-between items-center md:px-20 md:py-20 px-4 md:gap-0 gap-12 py-20">
            <div>
              <div className="text-5xl font-bold text-orange-500 mb-6">
                VENUE
              </div>
              <div className="text-2xl fold-bold text-white">
                Bhupen Hazarika Auditorium IIT Guwahati <br />
                Guwahati, Assam 781039
              </div>
            </div>
            <div>
              <img src={mapImage} className="md:h-[400px] h-[300px]" />
            </div>
          </div>
        </div>
      </main>
    </Layout>
  );
};

export default Home;
